import { sanitizeUrl } from "@braintree/sanitize-url";

export default function SanitizeUrl(url: string): string {
  return sanitizeUrl(url);
}
